import {
  UPDATE_LOAN_SUMMARY_START,
  UPDATE_LOAN_SUMMARY_SUCCESS,
  UPDATE_LOAN_SUMMARY_FAILURE,
} from './types';

export const updateLoanSummaryStart = (payload) => ({
  type: UPDATE_LOAN_SUMMARY_START,
  payload: payload,
})

export const updateLoanSummarySuccess = (payload) => ({
  type: UPDATE_LOAN_SUMMARY_SUCCESS,
  payload: payload,
})

export const updateLoanSummaryFailure = (payload) => ({
  type: UPDATE_LOAN_SUMMARY_FAILURE,
  payload: payload,
})
